import axios from 'axios';

export const GENERIC_ERROR_MESSAGE =
  'Não foi possível concluir a operação. Tente novamente. Se o problema persistir, entre em contato com o suporte.';

const messages: Record<string, string> = {
  'Failed to get payment config':
    'Não foi possível carregar as configurações de pagamento. Tente novamente.',
  'Failed to list audit history':
    'Não foi possível carregar o histórico de alterações. Tente novamente.',
  'Failed to update payment config':
    'Não foi possível salvar as configurações de pagamento. Tente novamente.',
  'quantityFrom must be less than or equal to quantityTo':
    'A quantidade inicial da faixa deve ser menor ou igual à quantidade final.',
  'Specific client price not found': 'Preço específico do cliente não encontrado.',
  'Accessory not found': 'Acessório não encontrado. Selecione outro acessório.',
  'Accessory is not active': 'O acessório está inativo. Selecione um acessório ativo.',
  'productId is required': 'Selecione um produto.',
  'accessoryId is required': 'Selecione um acessório.',
  'serviceId is required': 'Selecione um serviço.',
  'connectivityId is required': 'Selecione a conectividade.',
  'proposalId is required': 'Não foi possível identificar a proposta. Atualize a página.',
  'proposalId and editingItem are required':
    'Não foi possível identificar o item da proposta. Atualize o carrinho.',
  'Ranges are supported only for cash/installment product prices':
    'As faixas de quantidade estão disponíveis somente para preços de produtos à vista ou a prazo.',
  'Range quantityFrom must be greater than zero':
    'A quantidade inicial da faixa deve ser maior que zero.',
  'Range quantityTo must be greater than zero':
    'A quantidade final da faixa deve ser maior que zero.',
  'Range quantityTo must be greater than or equal to quantityFrom':
    'A quantidade final da faixa deve ser maior ou igual à quantidade inicial.',
  'Range priceInCents must be greater than or equal to zero':
    'O preço da faixa não pode ser negativo.',
  'First range must start at quantity 1': 'A primeira faixa deve começar na quantidade 1.',
  'Open-ended range can only be the last range for the same payment type':
    'Somente a última faixa de cada tipo de pagamento pode ficar sem quantidade final.',
  'Cannot have ranges after an open-ended range':
    'Não é possível adicionar faixas após uma faixa sem quantidade final.',
  'Ranges must be continuous for the same payment type':
    'As faixas do mesmo tipo de pagamento devem ser contínuas, sem lacunas ou sobreposição.',
  'Failed to fetch cart items': 'Não foi possível carregar os itens do carrinho. Tente novamente.',
  'Failed to calculate cart': 'Não foi possível calcular o carrinho. Tente novamente.',
  'Failed to add cart item': 'Não foi possível adicionar o item ao carrinho. Tente novamente.',
  'Failed to update cart item': 'Não foi possível atualizar o item do carrinho. Tente novamente.',
  'Failed to remove cart item': 'Não foi possível remover o item do carrinho. Tente novamente.',
  'Failed to fetch specific client prices':
    'Não foi possível carregar os preços específicos do cliente. Tente novamente.',
  'Failed to create specific client price':
    'Não foi possível criar o preço específico do cliente. Tente novamente.',
  'Failed to update specific client price':
    'Não foi possível atualizar o preço específico do cliente. Tente novamente.',
  'Failed to delete specific client price':
    'Não foi possível excluir o preço específico do cliente. Tente novamente.',
  'Reopen the proposal before changing delivery': 'Reabra a proposta antes de alterar a entrega.',
  'Delivery address not found':
    'Endereço de entrega não encontrado. Atualize a lista e selecione novamente.',
  'Delivery address does not belong to the proposal client':
    'O endereço selecionado não pertence ao cliente da proposta. Selecione um endereço deste cliente.',
  'Payment conditions must be configured before submitting':
    'Configure as condições de pagamento no carrinho antes de enviar a proposta.',
  'Delivery address must be set before submitting':
    'Selecione o destino no step Entrega antes de enviar a proposta.',
  'Proposal must have at least one cart item before submitting':
    'Adicione pelo menos um item ao carrinho antes de enviar a proposta.',
  'All SIM Card and Sale with SIM Card items must have connectivity details configured':
    'Configure a conectividade de todos os itens SIM Card e Venda com SIM Card antes de enviar a proposta.',
  'Can only submit proposals with OPEN status':
    'Só é possível enviar uma proposta aberta. Atualize a página e confira o status.',
  'Proposal changed concurrently':
    'A proposta foi alterada por outra operação. Atualize a página antes de tentar novamente.',
  'Proposal ID is required': 'Não foi possível identificar a proposta. Atualize a página.',
  'Missing required data for resend':
    'Não foi possível reenviar: faltam dados da proposta, do cliente ou da análise de crédito. Revise o cadastro.',
  'Required ID field missing for this negotiation type':
    'Selecione o item obrigatório para o tipo de negociação escolhido.',
  'Cannot add items to a proposal that is not OPEN':
    'Só é possível adicionar itens enquanto a proposta estiver aberta.',
  'Cannot remove items from a proposal that is not OPEN':
    'Só é possível remover itens enquanto a proposta estiver aberta.',
  'Cannot update items of a proposal that is not OPEN':
    'Só é possível alterar itens enquanto a proposta estiver aberta.',
  'Cart item not found': 'Item não encontrado no carrinho. Atualize a página.',
  'Cart item does not belong to this proposal':
    'O item não pertence a esta proposta. Atualize o carrinho.',
  'Service not found': 'Serviço não encontrado. Selecione outro serviço.',
  'Service product not found': 'Produto do serviço não encontrado. Revise o cadastro do serviço.',
  'Product not found': 'Produto não encontrado. Selecione outro produto.',
  'Product is not active': 'O produto está inativo. Selecione um produto ativo.',
  'No active price table found':
    'Nenhuma tabela de preços ativa foi encontrada. Ative uma tabela antes de continuar.',
  'SIM Card not found in active price table':
    'O SIM Card selecionado não está na tabela de preços ativa. Selecione novamente.',
  'Discount must be between 0 and 100': 'O desconto deve estar entre 0% e 100%.',
  'Connectivity discount must be between 0 and 100':
    'O desconto da conectividade deve estar entre 0% e 100%.',
  'No price found for this product and negotiation type':
    'O item não possui preço para o tipo de negociação escolhido. Revise a tabela de preços.',
  'Payment configuration not found. Cannot validate installments.':
    'Configure a porcentagem mínima de entrada e o máximo de parcelas em Comercial → Propostas → Configuração de Pagamento antes de salvar o pagamento a prazo.',
  'Cannot use INSTALLMENTS when cart contains only recurring items (SIM Card, Services). Use CASH instead.':
    'O carrinho contém somente itens recorrentes. Utilize pagamento à vista para essa composição.',
  'Cannot set payment for a proposal that is not OPEN':
    'Só é possível alterar o pagamento enquanto a proposta estiver aberta.',
  'Proposal status changed':
    'O status da proposta mudou. Atualize a página antes de tentar novamente.',
  'Proposal not found':
    'Proposta não encontrada. Atualize a página e confira a proposta selecionada.',
  'Installments must be at least 1': 'Informe a quantidade de parcelas.',
  'Due day must be between 1 and 31': 'Informe um dia de vencimento entre 1 e 31.',
  'Down payment percentage must be greater than 0 when enabled':
    'Informe uma porcentagem de entrada maior que zero ou desative a entrada.',
  'Entrada + freight exceeds total installment value. Reduce entrada or freight.':
    'A entrada ultrapassa o valor total financiável. Revise a entrada e o frete.',
  'Frete cannot be negative': 'O frete não pode ser negativo.',
  'CPF already registered': 'CPF já cadastrado.',
  'User with this document already exists': 'Já existe um usuário cadastrado com este CPF.',
  'Failed to create user in BWAUTH: User with this document already exists. Operation rolled back.':
    'Já existe um usuário cadastrado com este CPF.',
  'Email already registered': 'Email já cadastrado.',
  'Username already registered': 'Nome de usuário já cadastrado.',
  'Username already exists': 'Nome de usuário já cadastrado.',
  'Email already exists': 'Email já cadastrado.',
  'User not found': 'Usuário não encontrado.',
  'Profile not found': 'Perfil não encontrado.',
  'No changes were made': 'Nenhuma alteração foi realizada.',
  'An account with this document already exists': 'Documento já cadastrado!',
  'Invalid credentials': 'Usuário ou senha inválidos.',
  'Invalid email or password': 'Email ou senha inválidos.',
  Unauthorized: 'Sua sessão expirou. Entre novamente para continuar.',
  Forbidden: 'Você não tem permissão para realizar esta operação.',
  'Validation Error': 'Verifique os dados informados e tente novamente.',
  'Validation error': 'Verifique os dados informados e tente novamente.',
};

/** Only display translated, expected messages; never transport errors or technical details. */
export function translateErrorMessage(message: unknown, fallback = GENERIC_ERROR_MESSAGE): string {
  if (typeof message !== 'string' || !message.trim()) return fallback;
  const text = message.trim();
  if (Object.hasOwn(messages, text)) return messages[text];
  if (
    /^(productId|accessoryId|serviceId|connectivityId) is required for (SALE_WITH_SIM_CARD|SALE_WITHOUT_SIM_CARD|ACCESSORY_SALE|SIM_CARD|SERVICES)$/.test(
      text,
    )
  ) {
    return 'Selecione o item obrigatório para o tipo de negociação escolhido.';
  }
  if (
    /^A specific price already exists for this account, (product|accessory|SIM Card|service) and negotiation type$/.test(
      text,
    )
  ) {
    return 'Já existe um preço específico para este cliente, item e tipo de negociação.';
  }
  const minimumEntry =
    /^Entrada must be at least (\d+(?:\.\d+)?)% of total \(min: (\d+) cents\)$/.exec(text);
  if (minimumEntry) {
    const minimum = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
      Number(minimumEntry[2]) / 100,
    );
    return `A entrada deve ser de pelo menos ${minimumEntry[1]}% do valor dos itens (${minimum}). Aumente a porcentagem de entrada.`;
  }
  const maximumInstallments = /^Installments cannot exceed (\d+)$/.exec(text);
  if (maximumInstallments)
    return `O limite permitido é de ${maximumInstallments[1]} parcelas. Reduza a quantidade de parcelas.`;
  if (Object.values(messages).includes(text)) return text;
  if (text === 'O tempo de resposta foi excedido. Tente novamente.') return text;
  if (
    /request failed|network error|timeout|stack|SQL|ECONN|BWAUTH|\bS3\b|<html|\bat \w+\./i.test(
      text,
    )
  ) {
    return fallback;
  }
  // Domain messages already written in Portuguese can be preserved.
  if (
    /\b(não|nao|erro|falha|inválid[oa]s?|obrigatóri[oa]s?|encontrad[oa]s?|cadastrad[oa]s?|selecione|informe|verifique|permissão|possível|deve|precisa|aguarde|adicione|preencha|nenhum|nenhuma|existe|excede|tente|revise|permitid[oa]s?)\b/i.test(
      text,
    )
  ) {
    return text;
  }
  return fallback;
}

export function getErrorMessage(error: unknown, fallback = GENERIC_ERROR_MESSAGE): string {
  if (axios.isAxiosError(error)) {
    if (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT') {
      return 'O tempo de resposta foi excedido. Tente novamente.';
    }
    if (!error.response)
      return 'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.';
    if (error.response.status >= 500) return fallback;
    if (error.response.status === 401) return messages.Unauthorized;
    if (error.response.status === 403) return messages.Forbidden;
    if (error.response.status === 429)
      return 'Muitas tentativas em pouco tempo. Aguarde e tente novamente.';
    return translateErrorMessage(error.response.data?.message, fallback);
  }
  return translateErrorMessage(error instanceof Error ? error.message : error, fallback);
}
